import React from 'react'
import FaisalNavbar from '../../components/FaisalPage/FaisalNavbar'
import Footer from '../../components/Footer/Footer'
import FaisalContactInfo from '../../components/FaisalPage/FaisalContactInfo'

const FaisalContact = () => {
  return (
    <>
    <FaisalNavbar/>
    <FaisalContactInfo/>
    {/* <Footer/> */}
    </>
  )
}

export default FaisalContact
